'use strict';

import utils from './utils.js'

let {ajaxRequest, getDate, boxMessage} = utils

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* Name: 自制插件库
* Describe: 使用es6语法制作插件，简化代码，作为utils.js文件的延续。
* Attention: 在myPlugins.js文件中使用es6语法进行编写，为保证兼容性（主要是IE11不兼容es6），页面引入使用babel转化之后的myPlugins-es5.js文件；并将folyfill.js引入解决promise兼容性问题。
* Author: Bona
* */

var configs = JSON.parse(window.localStorage.getItem("configs")) || {};

/*if (!configs) {
    $.ajax({
        type: 'get',
        async: false,
        url: "/to-clue/all/config",
        contentType: "application/json;charset=UTF-8",
        dataType: 'json',
        success: function (data) {
            if (data.commonResponse.success) {
                configs = data.configMap;
                window.localStorage.setItem("configs", JSON.stringify(configs));
            } else {
                boxMessage("error", data.commonResponse.errorDesc);
            }
        }
    });
}*/
var urls = {
    pubOperateUrl: configs.zuulServerUrl, //公有云配置服务地址
    pubClueUrl: configs.zuulServerUrl, //公有云数据查询服务地址
    newsplatformUrl: configs.localClueUrl, //台内服务地址
    spiderUrl: configs.SpiderUrl //爬取服务地址


    /*
    * 1.省市县联动地域选择器
    * */
};
var Distpicker = function () {
    function Distpicker(options) {
        var _this = this;

        _classCallCheck(this, Distpicker);

        var defaultOptions = {
            element: '', //必要参数，传递放置插件的父元素，如'#distBox'
            clickProvince: function clickProvince(locationNamesArr, provinceId) {
                //必要参数，传递选择省之后的处理函数,
                throw new Error('参数clickProvince是必要参数');
            },
            clickCity: function clickCity(locationNamesArr, provinceId) {
                //必要参数，传递选择市之后的处理函数,
                throw new Error('参数clickCity是必要参数');
            },
            clickCounty: function clickCounty(locationNamesArr, provinceId) {
                //必要参数，传递选择市之后的处理函数,
                throw new Error('参数clickCounty是必要参数');
            },
            hasDefaultDist: false, //非必要参数，传递是否需要默认地域，布尔类型
            coverDefaultDist: null //菲必要参数，传递覆盖默认地域的地域位置，对象类型（level，standardAreaTag）
        };
        this.options = Object.assign({}, defaultOptions, options);
        if (!this.options.hasDefaultDist) {
            this.checkOptions().initHtmlAndBindEvents().catch(function (msg) {
                boxMessage('error', msg);
            });
            this.options.clickProvince();
        } else {
            this.getDefaultDist().then(function (response) {
                /*下面两个为测试数据*/
                /*response.result = {
                    level: 0,
                    standardAreaTag: '/湖北省'
                }*/
                /*response.result = {
                    level: 1,
                    standardAreaTag: '/湖北省/武汉市'
                }*/
                /*response.result = {
                    level: 2,
                    standardAreaTag: '/湖北省/武汉市/江夏区'
                }*/
                //判断是否传入覆盖默认地域的参数，进行覆盖操作
                if (_this.options.coverDefaultDist) {
                    response.result = _this.options.coverDefaultDist;
                }
                if (response.result && !$.isEmptyObject(response.result)) {
                    _this.checkOptions().initHtmlAndBindEvents().then(function (msg) {
                        _this.defaultDist(response);
                    }).catch(function (msg) {
                        boxMessage('error', msg);
                    });
                } else {
                    _this.checkOptions().initHtmlAndBindEvents().catch(function (msg) {
                        boxMessage('error', msg);
                    });
                    _this.options.clickProvince();
                }
            }).catch(function (msg) {
                boxMessage('error', msg);
            });
        }
    }

    //发送请求————获取用户默认地域


    _createClass(Distpicker, [{
        key: 'getDefaultDist',
        value: function getDefaultDist() {
            return new Promise(function (resolve, reject) {
                ajaxRequest({
                    type: 'get',
                    url: urls.pubOperateUrl + '/cluegather/v3/subscribe/area/default',
                    async: true,
                    success: function success(data) {
                        if (data.success) {
                            resolve(data);
                        } else {
                            reject('获取默认地域接口出错');
                        }
                    }
                });
            });
        }

        //发送请求————获取全国所有省

    }, {
        key: 'getProvinces',
        value: function getProvinces() {
            return new Promise(function (resolve, reject) {
                ajaxRequest({
                    type: 'get',
                    url: urls.pubOperateUrl + '/cluegather/v3/system/area/0',
                    async: true,
                    success: function success(data) {
                        if (data.success) {
                            resolve(data);
                        } else {
                            reject('获取所有省份失败');
                        }
                    }
                });
            });
        }

        //发送请求————获取对应省下面的所有市

    }, {
        key: 'getCity',
        value: function getCity(provinceId) {
            return new Promise(function (resolve, reject) {
                ajaxRequest({
                    type: 'get',
                    url: urls.pubOperateUrl + '/cluegather/v3/system/area/' + provinceId,
                    async: true,
                    success: function success(data) {
                        if (data.success) {
                            resolve(data);
                        } else {
                            reject('获取所有市失败');
                        }
                    }
                });
            });
        }

        //发送请求————获取对应市下面所有县

    }, {
        key: 'getCounty',
        value: function getCounty(cityId) {
            return new Promise(function (resolve, reject) {
                ajaxRequest({
                    type: 'get',
                    url: urls.pubOperateUrl + '/cluegather/v3/system/area/' + cityId,
                    async: true,
                    success: function success(data) {
                        if (data.success) {
                            resolve(data);
                        } else {
                            reject('获取所有区县失败');
                        }
                    }
                });
            });
        }

        //检查传参是否符合要求

    }, {
        key: 'checkOptions',
        value: function checkOptions() {
            if (!this.options.element) {
                throw new Error('参数element是必要参数');
            }
            return this;
        }

        //初始化下拉框中的内容，并绑定事件

    }, {
        key: 'initHtmlAndBindEvents',
        value: function initHtmlAndBindEvents() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                _this2.getProvinces().then(function (response) {
                    var provinceHtml = '<option>\u6240\u6709\u7701\u4EFD</option>';
                    var cityHtml = '<option>\u6240\u6709\u57CE\u5E02</option>';
                    var countyHtml = '<option>\u6240\u6709\u533A\u53BF</option>';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = response.resultList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var v = _step.value;

                            provinceHtml += '<option value="' + v.name + '" data-show-name="' + v.showName + '" data-area-id="' + v.areaId + '" data-standard-tag="' + v.standardTag + '" data-level="' + v.level + '" data-parentAreaId="' + v.parentAreaId + '">' + v.name + '</option>';
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    provinceHtml = '<select class="province" name="province" style="margin-right: 10px">' + provinceHtml + '</select>';
                    cityHtml = '<select class="city" name="city"  style="margin-right: 10px">' + cityHtml + '</select>';
                    countyHtml = '<select class="county" name="county">' + countyHtml + '</select>';
                    $(_this2.options.element).append(provinceHtml).append(cityHtml).append(countyHtml);
                    _this2._bindEvents(provinceHtml, cityHtml, countyHtml);
                    resolve('初始化下拉框成功');
                }).catch(function (msg) {
                    boxMessage('error', msg);
                });
            });
        }

        //处理默认地域

    }, {
        key: 'defaultDist',
        value: function defaultDist(data) {
            var _this3 = this;

            var distLevel = data.result.level;
            var defaultProvince = void 0;
            var defaultCity = void 0;
            var defaultCounty = void 0;
            if (distLevel === 0) {
                defaultProvince = data.result.standardAreaTag.split('/')[1];
                $(this.options.element).find('.province option').each(function (i, v) {
                    if ($(v).text().trim() == defaultProvince) {
                        $($(_this3.options.element).find('.province')[0]).val(defaultProvince).trigger('change');
                    }
                });
            } else if (distLevel === 1) {
                defaultProvince = data.result.standardAreaTag.split('/')[1];
                defaultCity = data.result.standardAreaTag.split('/')[2];
                $(this.options.element).find('.province option').each(function (i, v) {
                    if ($(v).text().trim() == defaultProvince) {
                        $($(_this3.options.element).find('.province')[0]).val(defaultProvince);
                        var provinceId = $(_this3.options.element).find('.province option:selected').data('areaId');
                        _this3.getCity(provinceId).then(function (response) {
                            var cityHtml = '';
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = response.resultList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var _v = _step2.value;

                                    cityHtml += '<option value="' + _v.name + '" data-area-id="' + _v.areaId + '" data-standard-tag="' + _v.standardTag + '" data-level="' + _v.level + '" data-parentAreaId="' + _v.parentAreaId + '">' + _v.name + '</option>';
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }

                            $($(_this3.options.element).find('.city')).append(cityHtml);
                            if (defaultCity) {
                                $($(_this3.options.element).find('.city')[0]).val(defaultCity).trigger('change');
                            } else {
                                //处理defaultCity为undefined
                                $($(_this3.options.element).find('.province')[0]).val(defaultProvince).trigger('change');
                            }
                        });
                    }
                });
            } else if (distLevel === 2) {
                defaultProvince = data.result.standardAreaTag.split('/')[1];
                defaultCity = data.result.standardAreaTag.split('/')[2];
                defaultCounty = data.result.standardAreaTag.split('/')[3];
                $(this.options.element).find('.province option').each(function (i, v) {
                    if ($(v).text().trim() == defaultProvince) {
                        $($(_this3.options.element).find('.province')[0]).val(defaultProvince);
                        var provinceId = $(_this3.options.element).find('.province option:selected').data('areaId');
                        _this3.getCity(provinceId).then(function (response) {
                            var cityHtml = '';
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = response.resultList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var _v2 = _step3.value;

                                    cityHtml += '<option value="' + _v2.name + '" data-area-id="' + _v2.areaId + '" data-standard-tag="' + _v2.standardTag + '" data-level="' + _v2.level + '" data-parentAreaId="' + _v2.parentAreaId + '">' + _v2.name + '</option>';
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }

                            $($(_this3.options.element).find('.city')).append(cityHtml);
                            $($(_this3.options.element).find('.city')[0]).val(defaultCity).trigger('change');
                            var cityId = $(_this3.options.element).find('.city option:selected').data('areaId');
                            _this3.getCounty(cityId).then(function (response) {
                                var countyHtml = '';
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = response.resultList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var _v3 = _step4.value;

                                        countyHtml += '<option value="' + _v3.name + '" data-area-id="' + _v3.areaId + '" data-standard-tag="' + _v3.standardTag + '" data-level="' + _v3.level + '" data-parentAreaId="' + _v3.parentAreaId + '">' + _v3.name + '</option>';
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }

                                $($(_this3.options.element).find('.county')).append(countyHtml);
                                if (defaultCounty) {
                                    $($(_this3.options.element).find('.county')[0]).val(defaultCounty).trigger('change');
                                } else {
                                    //处理defaultCounty为undefined
                                    $($(_this3.options.element).find('.city')[0]).val(defaultCity).trigger('change');
                                }
                            });
                        });
                    }
                });
            }
            return this;
        }

        //绑定事件

    }, {
        key: '_bindEvents',
        value: function _bindEvents(provinceHtml, cityHtml, countyHtml) {
            var _this4 = this;

            $($(this.options.element).find('.province')[0]).on('change', function (e) {
                var selectProvinceId = $($(_this4.options.element).find('.province option:selected')[0]).data('areaId');
                var locationNames = [$($(_this4.options.element).find('.province option:selected')[0]).data('standardTag')];
                $($(_this4.options.element).find('.city')).html(cityHtml);
                $($(_this4.options.element).find('.county')).html(countyHtml);
                if (selectProvinceId === undefined) {
                    locationNames.length = 0;
                    _this4.options.clickProvince(locationNames, selectProvinceId);
                } else {
                    _this4.getCity(selectProvinceId).then(function (response) {
                        var cityHtml = '';
                        var _iteratorNormalCompletion5 = true;
                        var _didIteratorError5 = false;
                        var _iteratorError5 = undefined;

                        try {
                            for (var _iterator5 = response.resultList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                var v = _step5.value;

                                cityHtml += '<option value="' + v.name + '" data-show-name="' + v.showName + '" data-area-id="' + v.areaId + '" data-standard-tag="' + v.standardTag + '" data-level="' + v.level + '" data-parentAreaId="' + v.parentAreaId + '">' + v.name + '</option>';
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }
                            } finally {
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }

                        $($(_this4.options.element).find('.city')).append(cityHtml);
                        if (locationNames[0] === '/北京市' || locationNames[0] === '/天津市' || locationNames[0] === '/上海市' || locationNames[0] === '/重庆市') {
                            $(_this4.options.element).find('.city').val('直辖区').trigger('change');
                        } else {
                            _this4.options.clickProvince(locationNames, selectProvinceId);
                        }
                    }).catch(function (msg) {
                        boxMessage('error', msg);
                    });
                }
            });
            $($(this.options.element).find('.city')[0]).on('change', function (e) {
                var selectProvinceId = $($(_this4.options.element).find('.province option:selected')[0]).data('areaId');
                var selectCityId = $($(_this4.options.element).find('.city option:selected')[0]).data('areaId');
                var locationNames = [$($(_this4.options.element).find('.city option:selected')[0]).data('standardTag')];
                $($(_this4.options.element).find('.county')).html(countyHtml);
                if (selectCityId === undefined) {
                    locationNames = [$($(_this4.options.element).find('.province option:selected')[0]).data('standardTag')];
                } else {
                    _this4.getCounty(selectCityId).then(function (response) {
                        var countyHtml = '';
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = response.resultList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var v = _step6.value;

                                countyHtml += '<option value="' + v.name + '" data-show-name="' + v.showName + '" data-area-id="' + v.areaId + '" data-standard-tag="' + v.standardTag + '" data-level="' + v.level + '" data-parentAreaId="' + v.parentAreaId + '">' + v.name + '</option>';
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }

                        $($(_this4.options.element).find('.county')).append(countyHtml);
                    }).catch(function (msg) {
                        boxMessage('error', msg);
                    });
                }
                _this4.options.clickCity(locationNames, selectProvinceId);
            });
            $($(this.options.element).find('.county')[0]).on('change', function (e) {
                var selectProvinceId = $($(_this4.options.element).find('.province option:selected')[0]).data('areaId');
                var selectCountyId = $($(_this4.options.element).find('.county option:selected')[0]).data('areaId');
                var locationNames = [$($(_this4.options.element).find('.county option:selected')[0]).data('standardTag')];
                if (selectCountyId === undefined) {
                    locationNames = [$($(_this4.options.element).find('.city option:selected')[0]).data('standardTag')];
                }
                _this4.options.clickCounty(locationNames, selectProvinceId);
            });
        }
    }]);

    return Distpicker;
}();

export {
    Distpicker,
}
